import { atom } from "jotai";
import { State } from "./State";
import { fetchBase, postBase } from "./BaseApi";

type Form = {
  email: string;
  password: string;
};

export const loginAtom = atom<State<null> | null>(null);

export const login = () => {
  const url = "api/login";
  return postBase<null, Form>(url, loginAtom);
};

type LoginCheck = {
  isLogin: boolean;
};

export const loginCheckAtom = atom<State<LoginCheck> | null>(null);

export const loginCheck = () => {
  const url = "api/login/check";
  return fetchBase<LoginCheck, null>(url, loginCheckAtom);
};
